export const candle_intervals = {
    "1m": "1 minute",
    "3m": "3 minutes",
    "5m": "5 minutes",
    "15m": "15 minutes",
    "30m": "30 minutes",
    "1h": "1 hour",
    "2h": "2 hours",
    "4h": "4 hours",
    "6h": "6 hours",
    "8h": "8 hours",
    "12h": "12 hours",
    "1d": "1 day",
    "3d": "3 days",
    "1w": "1 week",
    "1M": "1 month",
}
export const candle_interval = {
    m1: "1m",
    m3: "3m",
    m5: "5m",
    m15: "15m",
    m30: "30m",
    h1: "1h",
    h2: "2h",
    h4: "4h",
    h6: "6h",
    h8: "8h",
    h12: "12h",
    d1: "1d",
    d3: "3d",
    w1: "1w",
    M1: "1M"
}
